<template>
  <div data-v-2120e838>
    <div data-v-ba5e273c="" data-v-2120e838="" class="el-card is-never-shadow">
      <div class="el-card__body" style="padding: 5px;">
        <div data-v-ba5e273c="" class="el-row">
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/help" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-newurl"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">最新地址</div>
              </div>
            </a></div>
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/lists" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-new"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">最新信息</div>
              </div>
            </a></div>
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/publish" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-publish"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">发布信息</div>
              </div>
            </a></div>
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/upgrade" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-vip"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">升级VIP</div>
              </div>
            </a></div>
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/merchant" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-speaker"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">商家频道</div>
              </div>
            </a></div>
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/merchantjoin" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-hot"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">商家入驻</div>
              </div>
            </a></div>
          <div data-v-ba5e273c="" class="el-col el-col-24 el-col-xs-6 el-col-sm-6 el-col-md-3 el-col-xl-3"><a
              data-v-ba5e273c="" href="/help" class="HotText">
              <div data-v-ba5e273c="" class="HotBtn"><svg data-v-73b7ef61="" data-v-ba5e273c="" aria-hidden="true"
                  class="svg-icon" style="fill: rgb(255, 51, 153);">
                  <use data-v-73b7ef61="" xlink:href="#icon-message"></use>
                </svg>
                <div data-v-ba5e273c="" class="label">积分规则</div>
              </div>
            </a></div>
        </div>
      </div>
    </div>
    <div data-v-8a8c2ec6="" data-v-6ce0736f="" class="el-card is-never-shadow">
        <div class="el-card__body" style="padding: 5px;">
            <div data-v-8a8c2ec6="" class="G_Field">
                <div data-v-8a8c2ec6="" class="Label h_link">
                    热门城市：
                </div>
                <div data-v-8a8c2ec6="" class="Fields">
                    <a data-v-8a8c2ec6="" href="lists?cid=110000" class="top_link">北京</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=310000" class="top_link">上海</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=440100" class="top_link">广州</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=440300" class="top_link">深圳</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=330100" class="top_link">杭州</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=320100" class="top_link">南京</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=510100" class="top_link">成都</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=500000" class="top_link">重庆</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=420100" class="top_link">武汉</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=120000" class="top_link">天津</a>
                </div>
            </div>
            <div id="more-menu" style="display: none;">
            <div data-v-8a8c2ec6="" class="G_Field">
                <div data-v-8a8c2ec6="" class="Label h_link">
                    东北华北：
                </div>
                <div data-v-8a8c2ec6="" class="Fields">
                    <a data-v-8a8c2ec6="" href="lists?cid=110000" class="hot_link">北京市</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=120000" class="hot_link">天津市</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=370000" class="hot_link">山东省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=130000" class="hot_link">河北省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=140000" class="hot_link">山西省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=150000" class="hot_link">内蒙古</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=210000" class="hot_link">辽宁省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=230000" class="hot_link">黑龙江</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=220000" class="hot_link">吉林省</a>
                </div>
            </div>
            <div data-v-8a8c2ec6="" class="G_Field">
                <div data-v-8a8c2ec6="" class="Label h_link">
                    华中华东：
                </div>
                <div data-v-8a8c2ec6="" class="Fields">
                    <a data-v-8a8c2ec6="" href="lists?cid=310000" class="hot_link">上海市</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=320000" class="hot_link">江苏省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=330000" class="hot_link">浙江省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=350000" class="hot_link">福建省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=410000" class="hot_link">河南省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=420000" class="hot_link">湖北省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=430000" class="hot_link">湖南省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=340000" class="hot_link">安徽省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=360000" class="hot_link">江西省</a>
                </div>
            </div>
            <div data-v-8a8c2ec6="" class="G_Field">
                <div data-v-8a8c2ec6="" class="Label h_link">
                    西北西南：
                </div>
                <div data-v-8a8c2ec6="" class="Fields">
                    <a data-v-8a8c2ec6="" href="lists?cid=500000" class="hot_link">重庆市</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=510000" class="hot_link">四川省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=530000" class="hot_link">云南省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=520000" class="hot_link">贵州省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=610000" class="hot_link">陕西省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=620000" class="hot_link">甘肃省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=630000" class="hot_link">青海省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=650000" class="hot_link">新疆</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=640000" class="hot_link">宁夏</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=540000" class="hot_link">西藏</a>
                </div>
            </div>
            <div data-v-8a8c2ec6="" class="G_Field">
                <div data-v-8a8c2ec6="" class="Label h_link">
                    华南港澳：
                </div>
                <div data-v-8a8c2ec6="" class="Fields">
                    <a data-v-8a8c2ec6="" href="lists?cid=440000" class="hot_link">广东省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=450000" class="hot_link">广西</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=460000" class="hot_link">海南省</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=810000" class="hot_link">香港</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=820000" class="hot_link">澳门</a>
                    <a data-v-8a8c2ec6="" href="lists?cid=830000" class="hot_link">台湾</a>
                </div>
            </div>
            </div>
            <div data-v-8a8c2ec6="" class="c-btn">
                <button data-v-8a8c2ec6="" @click="more" type="button" class="el-button el-button--default el-button--mini is-round">{{moretext}}</button>
            </div>
        </div>
    </div>
    <div data-v-2120e838="" class="G-Title"><label data-v-2120e838=""><svg data-v-73b7ef61="" data-v-2120e838=""
          aria-hidden="true" class="svg-icon">
          <use data-v-73b7ef61="" xlink:href="#icon-hot"></use>
        </svg>
        热门信息：</label>
        <el-dropdown data-v-6ce0736f trigger="click" @command="indexselect">
            <span data-v-6ce0736f class="el-dropdown-link">{{indexhotname}}<i data-v-6ce0736f class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="dx" :disabled="currently">当下热门</el-dropdown-item>
                <el-dropdown-item command="yz" :disabled="thisweek">一周热门</el-dropdown-item>
                <el-dropdown-item command="by" :disabled="thismonth">本月热门</el-dropdown-item>
                <el-dropdown-item command="sy" :disabled="lasemonth">上月热门</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
    <div data-v-63c6a108 data-v-2120e838>
      <div data-v-63c6a108 class="el-row" style="z-index: 0;">
        <div v-for="v in top" data-v-63c6a108="" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8"><a
            data-v-63c6a108="" :href="'show?id='+v.id" class="">
            <div data-v-63c6a108="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
              <div class="el-card__body" style="padding: 0px; height: 160px;">
                <div data-v-63c6a108="" class="C-InfoCard">
                  <div data-v-63c6a108="" class="Content">
                    <div data-v-63c6a108="" class="Title">{{v.title}}</div>
                    <div data-v-63c6a108="">
                      <div data-v-63c6a108="" class="State">
                        <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                            class="svg-icon" style="fill: rgb(153, 153, 153);">
                            <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                          </svg> <span data-v-63c6a108="">{{v.create_time}}</span></div>
                        &nbsp;&nbsp;
                        <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                            class="svg-icon" style="fill: rgb(153, 153, 153);">
                            <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                          </svg> <span data-v-63c6a108="">{{v.browse}}</span></div>
                      </div>
                      <div data-v-63c6a108="" class="Desc">{{v.process}}</div>
                    </div>
                    <div data-v-63c6a108="" class="Location">
                      <div data-v-63c6a108="" class="Left"><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                          class="svg-icon" style="fill: rgb(255, 51, 153);">
                          <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                        </svg> <span data-v-63c6a108="">{{v.dz}}</span></div>
                      <div data-v-63c6a108="" class="Tags"> </div>
                    </div>
                  </div> <img data-v-63c6a108="" alt="img" :src="v.img" onerror="this.remove()" class="Cover">
                </div>
              </div>
            </div>
          </a>
        </div>
        <div v-for="v in indexdata" data-v-63c6a108="" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8"><a
            data-v-63c6a108="" :href="'show?id='+v.id" class="">
            <div data-v-63c6a108="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
              <div class="el-card__body" style="padding: 0px; height: 160px;">
                <div data-v-63c6a108="" class="C-InfoCard">
                  <div data-v-63c6a108="" class="Content">
                    <div data-v-63c6a108="" class="Title">{{v.title}}</div>
                    <div data-v-63c6a108="">
                      <div data-v-63c6a108="" class="State">
                        <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                            class="svg-icon" style="fill: rgb(153, 153, 153);">
                            <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                          </svg> <span data-v-63c6a108="">{{v.create_time}}</span></div>
                        &nbsp;&nbsp;
                        <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                            class="svg-icon" style="fill: rgb(153, 153, 153);">
                            <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                          </svg> <span data-v-63c6a108="">{{v.browse}}</span></div>
                      </div>
                      <div data-v-63c6a108="" class="Desc">{{v.process}}</div>
                    </div>
                    <div data-v-63c6a108="" class="Location">
                      <div data-v-63c6a108="" class="Left"><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                          class="svg-icon" style="fill: rgb(255, 51, 153);">
                          <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                        </svg> <span data-v-63c6a108="">{{v.dz}}</span></div>
                      <div data-v-63c6a108="" class="Tags"> </div>
                    </div>
                  </div> <img data-v-63c6a108="" alt="img" :src="v.img" onerror="this.remove()" class="Cover">
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'index',
  data() {
    return {
      indexhotname:'当下热门',
      currently:false,
      thisweek:false,
      thismonth:false,
      lasemonth:false,

      moretext:'+更多区域',

      top:[],
      indexdata:[],

      tanlink:'',
      tanimg:'',
    }
  },
  methods:{
    more(){

      let text = this.moretext
      if(text==='+更多区域'){
        this.moretext = '-收起'
      }else if(text==='-收起'){
        this.moretext = '+更多区域'
      }
      $("#more-menu").toggle(100);

    },
    indexselect(val){
      if(val=='dx'){
        this.indexdata = []

        this.currently = true;
        this.thisweek = false;
        this.thismonth = false;
        this.lasemonth = false;

        $(".el-dropdown-link").html('当下热门<i data-v-6ce0736f class="el-icon-arrow-down el-icon--right"></i>');

        this.$http.post('/api/index',{t:1}).then(res=>{

          this.indexdata = res.data.data

          if(res.data.top){

            this.top = res.data.top
            
          }

        })

      }else if(val=='yz'){
        this.indexdata = []

        this.currently = false;
        this.thisweek = true;
        this.thismonth = false;
        this.lasemonth = false;

        $(".el-dropdown-link").html('一周热门<i data-v-6ce0736f class="el-icon-arrow-down el-icon--right"></i>');

        this.$http.post('/api/index',{t:2}).then(res=>{

          this.indexdata = res.data.data

          if(res.data.top){

            this.top = res.data.top
            
          }
          
        })
        
      }else if(val=='by'){
        this.indexdata = []

        this.currently = false;
        this.thisweek = false;
        this.thismonth = true;
        this.lasemonth = false;

        $(".el-dropdown-link").html('本月热门<i data-v-6ce0736f class="el-icon-arrow-down el-icon--right"></i>');

        this.$http.post('/api/index',{t:3}).then(res=>{

          this.indexdata = res.data.data

          if(res.data.top){

            this.top = res.data.top
            
          }

        })

      }else if(val=='sy'){
        this.indexdata = []

        this.currently = false;
        this.thisweek = false;
        this.thismonth = false;
        this.lasemonth = true;

        $(".el-dropdown-link").html('上月热门<i data-v-6ce0736f class="el-icon-arrow-down el-icon--right"></i>');

        this.$http.post('/api/index',{t:4}).then(res=>{

          this.indexdata = res.data.data

          if(res.data.top){

            this.top = res.data.top
            
          }

        })

      }
    }
  },
  created(){

    this.$http.get('/api/tan').then(res=>{

      if(res.data.code==1){

        this.$alert('<a href="'+res.data.url+'" target="_blank"><img src="'+res.data.img+'" width="100%" height="100%"></a>','', {
          dangerouslyUseHTMLString: true,
          //showClose:false,
          showConfirmButton:false,
          center:true,
          customClass:'indextan',
          closeOnClickModal:true,
        });

      }

    })

    this.$http.post('/api/index',{t:1}).then(res=>{

      this.indexdata = res.data.data

      if(res.data.top){

        this.top = res.data.top
        
      }

    })

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/index.vue